import { RouteType } from '@/lib/route';
import Settings from '@/pages/Settings/index';

export enum TenantSettingsTabs {
  Publishing = 'publishing',
  Categories = 'categories',
  Theme = 'theme',
  Template = 'template',
}

export const SettingsBaseRoutes: RouteType = {
  path: '/settings/:tabSelected',
  component: Settings,
};

export const SettingsThemesRoutes: RouteType = {
  path: `/settings/${TenantSettingsTabs.Theme}`,
  component: Settings,
};

export const SettingsPublishingRoutes: RouteType = {
  path: `/settings/${TenantSettingsTabs.Publishing}`,
  component: Settings,
};

export interface SettingsParamTypes {
  tabSelected: string;
}

export default SettingsBaseRoutes;
